import { http } from 'services/http';
import { INVOICES_GET_MANY, INVOICES_GET_ONE } from 'api/query-keys.ts';
import type { InvoiceRes, UpdateInvoiceStatusReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateInvoiceStatus = (invoiceId: number) => {
  return useMutationBase<InvoiceRes, unknown, UpdateInvoiceStatusReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<InvoiceRes>(`/v1/invoices/${invoiceId}/status`, variables);

      return res.data;
    },

    invalidateCallback: ({ id }) => [[INVOICES_GET_ONE, id], [INVOICES_GET_MANY]],
  });
};
